/* unplugin-vue-components disabled */import { render } from "./tabs.vue?vue&type=template&id=ed220ea4&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"

import "./tabs.vue?vue&type=style&index=0&id=ed220ea4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed220ea4"],['__file',"src/controls/tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed220ea4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed220ea4', __exports__)) {
    api.reload('ed220ea4', __exports__)
  }
  
  module.hot.accept("./tabs.vue?vue&type=template&id=ed220ea4&scoped=true", () => {
    api.rerender('ed220ea4', render)
  })

}


export default __exports__